/**
 * Molecule Erectile Dysfunction Assessment — step config (Figma 1598:12972)
 *
 * To change the API field name for a question, edit that phase's `apiKey`
 * (and checkbox `apiKey` / `ackApiKey` / `otherApiKey` where present).
 * Engine stores answers under apiKey and posts them to create-ed-assessment.
 */
window.wmEdAssessmentConfig = {
  successRedirectUrl: '/pages/select-product',
  successRedirectDelayMs: 4000,
  disableSuccessRedirect: false,
  homeUrl: '/',
  clinicianBookingUrl: '/pages/book-a-consultation',
  storageKey: 'webmed_ed_assessment',
  storageTtlMs: 20 * 60 * 1000,
  formType: 'webmed_ed',
  api: {
    url: 'https://demo-app-config.looprx.io/api/create-ed-assessment',
    quizPlpUrl: 'https://demo-app-config.looprx.io/api/quiz-plp',
    tenant: 'webmed',
    formType: 'webmed_ed',
    categoryId: 2,
    authCookie: 'access_token'
  },
  phases: [
    {
      id: 'q0-details',
      type: 'details',
      showBack: false,
      heading: 'Please enter your details',
      nextLabel: 'Continue'
    },
    {
      id: 'q1-age',
      type: 'single',
      showBack: true,
      apiKey: 'is_18_or_older',
      heading: 'Are you 18 years of age or older?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no', nextPhaseId: 'kickout-8' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q2-sex-age',
      type: 'single',
      showBack: true,
      apiKey: 'is_male_aged_18_to_75',
      heading: 'Are you male and aged between 18 and 75?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no', nextPhaseId: 'kickout-9' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q3-symptoms',
      type: 'single',
      showBack: true,
      apiKey: 'difficulty_getting_erection',
      heading: 'Do you have difficulty getting or keeping an erection?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no', nextPhaseId: 'kickout-1' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q4-smoke-alcohol',
      type: 'single',
      showBack: true,
      apiKey: 'smokes_or_drinks_alcohol',
      heading: 'Do you smoke or drink alcohol?',
      options: [
        { label: 'Yes', value: 'yes', nextPhaseId: 'q4-important-info' },
        { label: 'No', value: 'no', nextPhaseId: 'q4-important-info' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q4-important-info',
      type: 'infoAck',
      showBack: true,
      apiKey: '_ui_smoke_alcohol_ack',
      heading: 'Important information',
      body:
        'You are eligible for treatment. However, be aware that alcoholic drinks and/or smoking can make erection difficulties worse. Consult your GP for information on giving up smoking.',
      confirmLabel: 'I understand and I will speak to my GP if required.',
      nextLabel: 'Continue'
    },
    {
      id: 'q5-previous-treatments',
      type: 'multiselect',
      showBack: true,
      apiKey: 'previous_ed_treatments',
      heading:
        'Erectile dysfunction treatments you have taken at least four times without side effects.',
      hint: 'Select all that apply',
      exclusiveValues: ['none', 'other'],
      otherValue: 'other',
      otherApiKey: 'previous_ed_treatments_other',
      otherPlaceholder: 'Please mention the treatment',
      options: [
        { label: 'Viagra (sildenafil)', value: 'viagra' },
        { label: 'Cialis (tadalafil)', value: 'cialis' },
        { label: 'Levitra (vardenafil)', value: 'levitra' },
        { label: 'Spedra (avanafil)', value: 'spedra' },
        { label: 'None of these', value: 'none' },
        { label: 'Other', value: 'other' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q6-frequency',
      type: 'single',
      showBack: true,
      apiKey: 'erection_difficulty_frequency',
      heading:
        'In the past six months, how often have you had difficulty getting or keeping an erection during sexual activity?',
      options: [
        { label: 'Always', value: 'always' },
        { label: 'Often', value: 'often' },
        { label: 'Occasionally', value: 'occasionally' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q7-high-bp',
      type: 'single',
      showBack: true,
      apiKey: 'has_high_blood_pressure',
      headingHtml:
        'Do you have high blood pressure <span class="wmaed__em">(above 160/90)</span> or are you currently receiving treatment for high blood pressure?',
      heading:
        'Do you have high blood pressure (above 160/90) or are you currently receiving treatment for high blood pressure?',
      hint:
        'If you do not know your blood pressure, you can have it measured at your local pharmacy or GP surgery.',
      options: [
        { label: 'Yes', value: 'yes', nextPhaseId: 'kickout-2' },
        { label: 'No', value: 'no' },
        { label: "I don't know", value: 'dont_know', nextPhaseId: 'kickout-10' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q8-low-bp',
      type: 'single',
      showBack: true,
      apiKey: 'has_low_blood_pressure',
      headingHtml:
        'Do you have low blood pressure <span class="wmaed__em">(below 90/50)</span>?',
      heading: 'Do you have low blood pressure (below 90/50)?',
      hint:
        'If you do not know your blood pressure, you can have it measured at your local pharmacy or GP surgery.',
      options: [
        { label: 'Yes', value: 'yes', nextPhaseId: 'kickout-3' },
        { label: 'No', value: 'no' },
        { label: "I don't know", value: 'dont_know' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q9-vigorous-exercise',
      type: 'single',
      showBack: true,
      apiKey: 'advised_avoid_vigorous_exercise',
      heading:
        'Have you been told to avoid vigorous exercise by a GP or another healthcare professional?',
      options: [
        { label: 'Yes', value: 'yes', nextPhaseId: 'kickout-4' },
        { label: 'No', value: 'no' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q10-exercise-ability',
      type: 'single',
      showBack: true,
      apiKey: 'difficulty_exercising_five_minutes',
      heading: 'Would you have any difficulty exercising for five minutes?',
      hint: 'For example, walking at a fast pace.',
      options: [
        { label: 'Yes', value: 'yes', nextPhaseId: 'kickout-5' },
        { label: 'No', value: 'no' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q11-depression',
      type: 'single',
      showBack: true,
      apiKey: 'depression_not_discussed_with_gp',
      heading: "Do you have depression that you haven't discussed with a GP?",
      options: [
        { label: 'Yes', value: 'yes', nextPhaseId: 'kickout-6' },
        { label: 'No', value: 'no' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q12-reactions',
      type: 'single',
      showBack: true,
      apiKey: 'ed_treatment_allergic_reaction',
      heading:
        'Have you ever had an allergic reaction or serious side effect from an erectile dysfunction treatment?',
      hint:
        'For example, Viagra (sildenafil), Cialis (tadalafil), Levitra (vardenafil) or Spedra (avanafil).',
      options: [
        { label: 'Yes', value: 'yes', nextPhaseId: 'kickout-7' },
        { label: 'No', value: 'no' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q13-medical-conditions',
      type: 'multiselect',
      showBack: true,
      apiKey: 'medical_conditions',
      heading: 'Have you ever experienced any of the following?',
      hint: 'Select all that apply',
      exclusiveValue: 'none',
      exclusiveValues: ['none', 'other'],
      otherValue: 'other',
      // Free text is inlined on submit as "Other - {text}" in medical_conditions
      otherPlaceholder: 'Please mention the treatment',
      options: [
        {
          label:
            'Any heart problem, including angina, chest pain, heart failure, irregular heartbeat, heart attack (myocardial infarction), left-ventricular outflow obstruction, cardiomyopathy or valvular heart disease such as aortic stenosis',
          value: 'heart_problem'
        },
        {
          label: 'Stroke or TIA (mini-stroke) in the last six months',
          value: 'stroke_tia'
        },
        {
          label:
            'Sight loss caused by poor circulation or damage to the optic nerve (non-arteritic ischaemic optic neuropathy)',
          value: 'optic_neuropathy'
        },
        {
          label: 'A hereditary retinal problem such as retinitis pigmentosa',
          value: 'retinitis_pigmentosa'
        },
        {
          label: 'A bleeding disorder such as haemophilia',
          value: 'bleeding_disorder'
        },
        { label: 'Sickle cell anaemia', value: 'sickle_cell' },
        { label: 'Leukaemia', value: 'leukaemia' },
        { label: 'Myeloma', value: 'myeloma' },
        {
          label: 'Stomach ulcers, such as a peptic or gastric ulcer',
          value: 'stomach_ulcers'
        },
        { label: 'Liver problems', value: 'liver_problems' },
        { label: 'Kidney problems', value: 'kidney_problems' },
        {
          label: 'An erection that lasted longer than four hours',
          value: 'priapism'
        },
        {
          label:
            'A physical condition affecting the shape of the penis, such as angulation, Peyronie’s disease or cavernosal fibrosis',
          value: 'penile_deformity'
        },
        { label: 'A previous injury to the penis', value: 'penile_injury' },
        {
          label: 'An inability to retract the foreskin',
          value: 'phimosis'
        },
        { label: 'Galactose intolerance', value: 'galactose_intolerance' },
        { label: 'Lapp lactase deficiency', value: 'lapp_lactase' },
        {
          label: 'Glucose-galactose malabsorption',
          value: 'glucose_galactose'
        },
        {
          label:
            'A serious medical condition that may require immediate hospitalisation',
          value: 'serious_condition'
        },
        { label: 'None of the above', value: 'none' },
        { label: 'Other', value: 'other' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q14-medications',
      type: 'multiselect',
      showBack: true,
      apiKey: 'current_medications_check',
      heading: 'Are you currently taking any of the following?',
      exclusiveValue: 'none',
      exclusiveValues: ['none', 'other'],
      otherValue: 'other',
      // Free text is inlined on submit as "Other - {text}" in current_medications_check
      otherPlaceholder: 'Please mention the treatment',
      options: [
        {
          label:
            'Any erectile dysfunction treatment apart from Viagra (sildenafil), Cialis (tadalafil), Levitra (vardenafil) or Spedra (avanafil)',
          value: 'other_ed_treatment'
        },
        {
          label:
            'Medicinal nitrates, including glyceryl trinitrate, isosorbide mononitrate or isosorbide dinitrate—oral, transdermal or sublingual',
          value: 'nitrates'
        },
        {
          label: 'Recreational drugs prohibited by law (Class A, B or C)',
          value: 'recreational_drugs'
        },
        {
          label:
            'Recreational nitrites such as amyl nitrite, also known as “poppers”',
          value: 'poppers'
        },
        {
          label:
            'Alpha blockers, including tamsulosin, doxazosin, prazosin, terazosin or indoramin',
          value: 'alpha_blockers'
        },
        {
          label: 'Medicines used to treat high blood pressure',
          value: 'bp_medicines'
        },
        { label: 'Warfarin', value: 'warfarin' },
        {
          label:
            'Antivirals, including atazanavir, etravirine, fosamprenavir, indinavir, nelfinavir, ritonavir, saquinavir, darunavir or lenacapavir',
          value: 'antivirals'
        },
        { label: 'Nicorandil', value: 'nicorandil' },
        { label: 'Diltiazem', value: 'diltiazem' },
        {
          label:
            'Antifungal medication such as ketoconazole, itraconazole or fluconazole',
          value: 'antifungals'
        },
        { label: 'Quinidine', value: 'quinidine' },
        { label: 'Procainamide', value: 'procainamide' },
        { label: 'Amiodarone', value: 'amiodarone' },
        { label: 'Dronedarone', value: 'dronedarone' },
        { label: 'Theophylline', value: 'theophylline' },
        { label: 'Erythromycin', value: 'erythromycin' },
        { label: 'Clarithromycin', value: 'clarithromycin' },
        { label: 'Rifampicin', value: 'rifampicin' },
        { label: 'Phenobarbital', value: 'phenobarbital' },
        { label: 'Phenytoin', value: 'phenytoin' },
        { label: 'Carbamazepine', value: 'carbamazepine' },
        { label: 'Riociguat', value: 'riociguat' },
        { label: 'Cimetidine', value: 'cimetidine' },
        { label: 'None of the above', value: 'none' },
        { label: 'Other', value: 'other' }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'q15-consent',
      type: 'dualConfirm',
      showBack: true,
      heading: 'Please check that you understand and agree to the following:',
      body:
        'I understand that erectile dysfunction can be associated with contributing conditions such as hypertension, diabetes mellitus, high cholesterol or cardiovascular disease, and that I should consult my doctor within six months of starting treatment for a clinical review. In the rare event that I experience an erection lasting longer than four hours or any sudden visual impairment, I will seek immediate medical assistance. I will read the patient information leaflet supplied with my medication. I will contact Molecule and inform my GP if I experience any side effects from treatment, start new medication or my medical conditions change during treatment. The treatment is solely for my own use. I have answered all questions accurately and truthfully. I understand that prescribers take my answers in good faith and base their prescribing decisions accordingly, and that incorrect information can be hazardous to my health.',
      checkboxes: [
        {
          apiKey: '_ui_confirm_understand',
          label: 'I confirm that I understand and agree to the above.'
        },
        {
          apiKey: '_ui_agree_terms',
          label: 'I agree to the Terms and Conditions and confirm that I am over 18.'
        }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'p-intro',
      type: 'intro',
      showBack: true,
      heading: 'Almost there! Let’s personalise your treatment.',
      body: 'This will help us pick the best treatment for you',
      nextLabel: 'Continue'
    },
    {
      id: 'p1-lifestyle',
      type: 'single',
      showBack: true,
      apiKey: 'treatment_lifestyle',
      heading: 'What best suits your lifestyle?',
      options: [
        {
          label: 'Daily use',
          value: 'daily',
          description: 'Be ready for when the mood takes you. Best for spontaneous sex.',
          nextPhaseId: 'p3-recommendation'
        },
        {
          label: 'As needed',
          value: 'as_needed',
          description: 'Take the treatment an hour before you plan to have sex.',
          nextPhaseId: 'p2b-as-needed'
        }
      ],
      nextLabel: 'Continue'
    },
    {
      id: 'p2b-as-needed',
      type: 'preference',
      showBack: true,
      apiKey: 'as_needed_treatment_preference',
      ackApiKey: '_ui_as_needed_claims_ack',
      heading: 'When it comes to ED treatment, what is most important to you?',
      ackLabel:
        'The accuracy and presentation of these product claims should be approved before publication.',
      options: [
        {
          label: 'Stay ready for longer',
          value: 'longer',
          description: 'Tadalafil (Cialis) up to 36 hours of effect.'
        },
        {
          label: 'Fast acting',
          value: 'fast',
          description: 'Sildenafil (Viagra) starts working in around 15 minutes.'
        }
      ],
      nextLabel: 'Continue',
      nextPhaseId: 'p3-recommendation'
    },
    {
      id: 'p3-recommendation',
      type: 'single',
      showBack: true,
      apiKey: 'wants_treatment_guidance',
      heading: 'Would you like guidance in choosing your ED treatment?',
      options: [
        {
          label: 'Yes, I’d like recommendations, including more effective options.',
          value: 'yes_recommendations'
        },
        {
          label: 'No, I already know what works for me.',
          value: 'no_know_what_works'
        }
      ],
      nextLabel: 'Submit',
      finish: true
    },

    /* Kickouts (routeOnly) */
    {
      id: 'kickout-8',
      type: 'kickout',
      routeOnly: true,
      hideChrome: true,
      textAlign: 'center',
      heading: 'This service is for adults only',
      body:
        "ED treatment is only available to people aged 18 and over. If you're worried about your health, please speak to your GP.",
      nextLabel: 'Book a Clinician Review',
      nextAction: 'book-clinician'
    },
    {
      id: 'kickout-9',
      type: 'kickout',
      routeOnly: true,
      hideChrome: true,
      heading: "This treatment isn't available through this service",
      body:
        "Based on your answers, we're not able to offer this treatment online. Your GP can talk you through the options that are right for you.",
      nextLabel: 'Book a Clinician Review',
      nextAction: 'book-clinician'
    },
    {
      id: 'kickout-1',
      type: 'kickout',
      routeOnly: true,
      hideChrome: true,
      heading: 'This treatment may not be right for you',
      body:
        "Based on your answers, it doesn't look like you're experiencing erectile dysfunction. If you have concerns, your GP can help you find out what's going on",
      nextLabel: 'Book a Clinician Review',
      nextAction: 'book-clinician'
    },
    {
      id: 'kickout-2',
      type: 'kickout',
      routeOnly: true,
      hideChrome: true,
      heading: "This isn't safe to prescribe right now",
      body:
        "It isn't safe to start ED treatment with high blood pressure. Once it's managed by your GP, you may be able to start treatment",
      nextLabel: 'Home',
      nextAction: 'go-home'
    },
    {
      id: 'kickout-10',
      type: 'kickout',
      routeOnly: true,
      hideChrome: true,
      heading: "We'll need your blood pressure first",
      body:
        "If you don't know your blood pressure, please have it measured at a pharmacy or GP surgery before we can safely prescribe online.",
      nextLabel: 'Home',
      nextAction: 'go-home'
    },
    {
      id: 'kickout-3',
      type: 'kickout',
      routeOnly: true,
      hideChrome: true,
      heading: "This isn't safe to prescribe right now",
      body:
        "ED treatment can lower blood pressure further, so we can't prescribe it while yours is low. Please speak to your GP for advice.",
      nextLabel: 'Home',
      nextAction: 'go-home'
    },
    {
      id: 'kickout-4',
      type: 'kickout',
      routeOnly: true,
      hideChrome: true,
      heading: "We'd recommend a GP review first",
      body:
        "Sexual activity puts strain on the heart, so we can't prescribe without a doctor checking this is safe for you. Please book in with your GP",
      nextLabel: 'Home',
      nextAction: 'go-home'
    },
    {
      id: 'kickout-5',
      type: 'kickout',
      routeOnly: true,
      hideChrome: true,
      heading: "We'd recommend a GP review first",
      body:
        "Sexual activity puts strain on the heart, so we can't prescribe without a doctor checking this is safe for you. Please book in with your GP",
      nextLabel: 'Home',
      nextAction: 'go-home'
    },
    {
      id: 'kickout-6',
      type: 'kickout',
      routeOnly: true,
      hideChrome: true,
      heading: "Let's involve your GP first",
      body:
        "It's worth talking to your GP about how you've been feeling before starting ED treatment. They can support you and advise on the right options",
      nextLabel: 'Home',
      nextAction: 'go-home'
    },
    {
      id: 'kickout-7',
      type: 'kickout',
      routeOnly: true,
      hideChrome: true,
      heading: "This needs a doctor's review",
      body:
        "As you've had a reaction to ED treatment before, it isn't safe to prescribe online. Please speak to your GP about safer alternatives.",
      actions: [
        { label: 'Book a Clinician Review', action: 'book-clinician' },
        { label: 'Home', action: 'go-home' }
      ]
    }
  ]
};
